import { render, staticRenderFns } from "./ItemWidgetText.vue?vue&type=template&id=78121777&scoped=true&"
import script from "./ItemWidgetText.vue?vue&type=script&lang=js&"
export * from "./ItemWidgetText.vue?vue&type=script&lang=js&"
import style0 from "./ItemWidgetText.vue?vue&type=style&index=0&id=78121777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78121777",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
